/*!
 * Kindred Wooden — Google Tag events (add_to_cart / cart_view)
 * Piggybacks on the base gtag loaded by snippets/kw-google-tag.liquid.
 * Handles all "in-storefront" events. Purchase event lives in the
 * Custom Web Pixel (Shopify Admin → Settings → Customer events).
 */
(function () {
  'use strict';
  if (typeof window.gtag !== 'function') {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { dataLayer.push(arguments); };
  }

  var AW = 'AW-18434469267';

  // Helpers ------------------------------------------------------------
  function money(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2);
  }
  function pushEvent(name, params) {
    try { window.gtag('event', name, params); } catch (e) {}
    try { window.dataLayer.push(Object.assign({ event: name }, params)); } catch (e) {}
  }

  // Fetch monkey-patch to detect Shopify cart mutations
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var promise = origFetch.apply(this, arguments);
    if (url && /\/cart\/(add|change|update|clear)\.js/.test(url)) {
      promise.then(function (res) {
        if (!res.ok) return;
        return res.clone().json().then(function (data) {
          if (!data) return;
          if (/\/cart\/add\.js/.test(url)) {
            var items = data.items || [data];
            items.forEach(function (it) {
              pushEvent('add_to_cart', {
                currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
                value: parseFloat(money(it.line_price || it.final_line_price || it.price)),
                items: [{
                  item_id: it.sku || String(it.variant_id || it.id),
                  item_name: it.product_title || it.title,
                  item_brand: 'Kindred Wooden',
                  item_variant: it.variant_title,
                  price: parseFloat(money(it.price)),
                  quantity: it.quantity || 1
                }]
              });
            });
          }
        }).catch(function () {});
      });
    }
    return promise;
  };

  // XMLHttpRequest monkey-patch (fallback for older Shopify AJAX carts)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kw_url = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__kw_url && /\/cart\/add\.js/.test(xhr.__kw_url)) {
      xhr.addEventListener('load', function () {
        try {
          var data = JSON.parse(xhr.responseText);
          if (data && data.items) {
            data.items.forEach(function (it) {
              pushEvent('add_to_cart', {
                currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
                value: parseFloat(money(it.line_price || it.price)),
                items: [{
                  item_id: it.sku || String(it.variant_id || it.id),
                  item_name: it.product_title || it.title,
                  item_brand: 'Kindred Wooden',
                  quantity: it.quantity || 1
                }]
              });
            });
          }
        } catch (e) {}
      });
    }
    return origSend.apply(this, arguments);
  };

  // begin_checkout: fires when user clicks any /checkout link or cart submit
  document.addEventListener('click', function (e) {
    var target = e.target.closest && e.target.closest('a[href*="/checkout"], button[name="checkout"], form[action*="/cart"] [type="submit"]');
    if (target) {
      pushEvent('begin_checkout', { currency: 'USD' });
    }
  }, true);

  // view_cart: fires when cart drawer opens (Horizon uses <cart-drawer> element)
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
    if (!drawer) return;
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName === 'open' || m.attributeName === 'aria-hidden' || m.attributeName === 'class') {
          if (drawer.hasAttribute('open') || !drawer.hasAttribute('aria-hidden') || (drawer.className || '').indexOf('is-open') !== -1) {
            pushEvent('view_cart', {});
          }
        }
      });
    });
    obs.observe(drawer, { attributes: true });
  });
})();
